import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers,URLSearchParams,ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Notifications } from '../models/notifications';
import { UserAccount } from '../models/account';
import { Client } from '../models/client';
import { Grouping } from '../models/groupings';
import { Schedule } from '../models/schedule';
import { Assessment } from '../models/assessment';
import { Batteries } from '../models/batteries';
import { Practice } from '../models/practice';
import { Template } from '../models/template';
// import { Questions } from '../models/questions';

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  //url: string = 'https://dev-api.novopsych.com';
  url: string = 'https://growingminds-api.novopsych.com';
  //url: string = 'http://localhost:8100/v1';

  credentials: any;

  constructor(public http: Http) {

  }

  resetPassword(endpoint: string, body: any) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Novopsych', 'webapp');
    let options = new RequestOptions({ headers: headers});
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),options)
      .map(res => res.json().data)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
    }

    verifyAccount(endpoint: string, body: any) {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      headers.append('Novopsych', 'webapp');
      let options = new RequestOptions({ headers: headers});
      var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),options)
        .map(res => res.json().data)
        .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
      return response;
      }  

    resendVerification(endpoint: string, body: any, email: string, password: string) {
      var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createCustomAuthorizationHeader(email, password));
      return response;
      
    }

  changePassword(endpoint: string, body: any, id: string) {
    var response =  this.http.put(this.url + '/' + endpoint + '/' + id, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  changePreference(endpoint: string, body: any, id: string) {
    var response =  this.http.put(this.url + '/' + endpoint + '/' + id, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  sendFeedback(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader())
      .map(res => res.json().data)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

  }

  login(endpoint: string, credentials) {
    this.credentials = credentials;
    return new Promise((resolve, reject) => {
      let headers = new Headers({ 'Content-Type': 'application/json' });
          headers.append('Novopsych', 'webapp');
      //headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Authorization', "Basic ".concat(btoa(this.credentials.username+':'+this.credentials.password)));
      let options = new RequestOptions({ headers: headers });
      this.http.get(this.url + '/' + endpoint, options)
        .subscribe(res => {
          resolve(res.json());
        }, (err) => {
          reject(err);
        });

    });
 }

 getAccountDetails(endpoint: string): Observable<UserAccount> {
  var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
    .map(res => <UserAccount>res.json().data.user)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
}

 register(endpoint: string, body: any) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Novopsych', 'webapp');
    //headers.append('Access-Control-Allow-Origin', '*');
    //headers.append('Access-Control-Allow-Methods', 'GET,HEAD,OPTIONS,POST,PUT');
    let options = new RequestOptions({ headers: headers});
    return this.http.post(this.url + '/' + endpoint, JSON.stringify(body), options);
  }

  addClient(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader());
      //.map(res => res.json().data)
      //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

  }

  editClient(endpoint: string, body: any, clientId:string) {
    var response =  this.http.post(this.url + '/' + endpoint + '/' + clientId, JSON.stringify(body),this.createAuthorizationHeader());
      //.map(res => res.json().data)
      //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
    
  }

  clientChangeStatus(endpoint: string, clientId: string, status:string) {
    var body = {
      'id': clientId,
      'status': status
    }
    var response =  this.http.put(this.url + '/' + endpoint + '/' + clientId, JSON.stringify(body),this.createAuthorizationHeader());
      //.map(res => res.json().data)
      //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  setClientGrouping(endpoint: string, clientIds: string, groupingId:string, create:boolean) {
    var body = {
      'ids': clientIds,
      'grouping_id': groupingId,
      'create': create
    }
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader());
      //.map(res => res.json().data)
      //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
    
  }

  planSignup(endpoint: string, body: any, clientId:string) {
    var response =  this.http.post(this.url + '/' + endpoint + '/' + clientId + '?planSignup=1', JSON.stringify(body),this.createAuthorizationHeader());
      //.map(res => res.json().data)
      //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
    
  }

  deleteClient(endpoint: string, body: any, clientId:string) {

    var response =  this.http.put(this.url + '/' + endpoint + '/' + clientId, JSON.stringify(body),this.createAuthorizationHeader());
      //.map(res => res.json().data)
      //.catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

  }

  addNote(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint + '/' + body.clientId + '/' + 'notes', JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  updateNote(endpoint: string, body: any) {
    var response =  this.http.put(this.url + '/' + endpoint + '/' + body.id, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  deleteNote(endpoint: string, id: string) {
    return this.http.delete(this.url + '/' + endpoint + '/' + id, this.createAuthorizationHeader());

  }

  updateUser(endpoint: string, body: any, id: string) {
    var response =  this.http.put(this.url + '/' + endpoint + '/' + id, JSON.stringify(body),this.createAuthorizationHeader());
    return response;
    
  }

  updatePracticeName(endpoint: string, body: any, id: string) {
    var response =  this.http.put(this.url + '/' + endpoint + '/' + id, JSON.stringify(body),this.createAuthorizationHeader());
    return response;
    
  }
  //Added on 29/09/2019 for add user functionality
  getUsers(endpoint: string): Observable<any[]> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <any[]>res.json().data.users)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  addUser(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  deleteUser(endpoint: string, id: any) {
    var response =  this.http.delete(this.url + '/' + endpoint + '/' + id, this.createAuthorizationHeader());
    return response;
    
  }

  assignGrouping(endpoint: string, body: any) {
    var response =  this.http.put(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader());
    return response;
    
  }

  joinPractice(endpoint: string, inviteId: any) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Novopsych', 'webapp');
    let options = new RequestOptions({ headers: headers});
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(inviteId),options);
    return response;
  }

  getClients(endpoint: string): Observable<Client[]> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <Client[]>res.json().data.clients)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getClientsPaged(endpoint: string): Observable<any> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <any[]>res.json().data.clients)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getSchedules(endpoint: string): Observable<any[]> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <any[]>res.json().data.schedules)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getPractices(endpoint: string): Observable<Practice> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <Practice>res.json().data.practice)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  createEmailTemplate(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint , JSON.stringify(body),this.createAuthorizationHeader());
    return response;
    
  }

  getEmailTemplates(endpoint: string): Observable<Template[]> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <Template[]>res.json().data.templates)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getClientNotesAndResponses(endpoint: string, clientId: string): Observable<Client> {
    var response = this.http.get(this.url + '/' + endpoint + '/' + clientId, this.createAuthorizationHeader())
      .map(res => <Client>res.json().data.client)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getNews(endpoint: string, body): Observable<Notifications> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <Notifications>res.json().data)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getVersion(endpoint: string) {
    var response =  this.http.post(this.url + '/' + endpoint, null,this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getAssessments(endpoint: string, version: string): Observable<Assessment[]> {
    let assessmentVersion = new URLSearchParams();
    assessmentVersion.set('version', version);
    let options = this.createAuthorizationHeader();
    options.search = assessmentVersion
    var response = this.http.get(this.url + '/' + endpoint + '/', options)
      .map(res => <Assessment[]>res.json().data.assessments)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

getAssessmentQuestions(endpoint: string, assessmentId: string, uniqueId: string) {
  let options = this.createAuthorizationHeader();
  let scheduleUniqueId = new URLSearchParams();
  if(uniqueId){
    scheduleUniqueId.set('schedule', uniqueId);
    options.search = scheduleUniqueId; //try commenting this out and then try having a seperate if else block
  }
  var response = this.http.get(this.url + '/' + endpoint+ '/' + assessmentId, options)
  .map(res => res.json().data)
  .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;

}

getAssessmentForSchedule(endpoint: string, scheduleId: string) {
  var response = this.http.get(this.url + '/' + endpoint+ '/' + scheduleId)
  .map(res => res.json().data)
  .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;

}

unsubscribe(endpoint: string, scheduleId: string) {
  var response = this.http.get(this.url + '/' + endpoint+ '/' + scheduleId + '?' + 'unsubscribe')
  .map(res => res.json().data)
  .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;

}

submitAssessment(endpoint: string, clientId: string, body: any, answer:any) {
  var response = this.http.post(this.url + '/' + endpoint+ '/' + clientId+ '/' + 'responses',JSON.stringify({ answer: answer, response: body }), this.createAuthorizationHeader())
  .map(res => res.json().data.assessment)
  .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;

}

  submitScheduledAssessment(endpoint: string, body: any, answer: any) {
    var response = this.http.post(this.url + '/' + endpoint, JSON.stringify({ answer: answer, response: body }), this.createAuthorizationHeader())
      .map(res => res.json().data)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

}



  scheduleAssessments(endpoint: string, body: any){
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
  }

  getAssessmentsURL(endpoint: string, body: any){
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
  }

  editScheduleAssessments(endpoint: string, body: any, scheduleId: string){
    var response =  this.http.post(this.url + '/' + endpoint + '/' + scheduleId, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
  }

  downloadAssessment(endpoint: string, assessmentId: string){
    var response =  this.http.get(this.url + '/' + endpoint + '/' + 'form' + '/'+ assessmentId,this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
  }

  getScheduledAssessments(endpoint: string, scheduleId: string): Observable<Schedule> {
    var response = this.http.get(this.url + '/' + endpoint + '/' + scheduleId, this.createAuthorizationHeader())
      .map(res => <Schedule>res.json().data.schedule)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  deleteSchedule(endpoint: string, scheduleId: string){
    return this.http.delete(this.url + '/' + endpoint + '/' + scheduleId, this.createAuthorizationHeader());
  }

  deleteReport(endpoint: string, reportId: string){
    return this.http.delete(this.url + '/' + endpoint + '/' + reportId, this.createAuthorizationHeader());
  }

  changeDate(endpoint: string, reportId: string , body: any){
    var response =  this.http.post(this.url + '/' + endpoint + '/' + reportId, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
  }

  assignClient(endpoint: string, reportId: string , body: any){
    var response =  this.http.post(this.url + '/' + endpoint + '/' + reportId, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  return response;
  }

  // grouping

  getGroupings(endpoint: string): Observable<any[]> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <any[]>res.json().data.groupings)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  addGrouping(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  editGrouping(endpoint: string, body: any, groupingId: string) {
    var response =  this.http.post(this.url + '/' + endpoint + '/' + groupingId, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  deleteGrouping(endpoint: string, groupingId:string) {
    return this.http.delete(this.url + '/' + endpoint + '/' + groupingId, this.createAuthorizationHeader());

  }

  getClientGrouping(endpoint: string, groupingId:string) {
    var response = this.http.get(this.url + '/' + endpoint + '/' + groupingId, this.createAuthorizationHeader())
      .map(res => <any[]>res.json().data.groupings)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

  }

  addClientGrouping(endpoint: string, body: any, groupingId:string) {
    var response =  this.http.post(this.url + '/' + endpoint + '/' + groupingId, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

  }

  deleteClientGrouping(endpoint: string, body: any, groupingId:string) {
    var response =  this.http.post(this.url + '/' + endpoint + '/' + groupingId, JSON.stringify(body),this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;

  }

  addToken(endpoint: string) {
    var response =  this.http.post(this.url + '/' + endpoint, null,this.createAuthorizationHeader())
    .map(res => res.json().data)
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  private createAuthorizationHeader() {
    let userId = localStorage.getItem('userId');
    let password = localStorage.getItem('password');
    if (userId && password) {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      headers.append('Novopsych', 'webapp');
      //headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Authorization', "Basic ".concat(btoa(userId+':'+password)));
      return new RequestOptions({ headers: headers });
  }else{
    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Novopsych', 'webapp');
    //headers.append('Access-Control-Allow-Origin', '*');
    return new RequestOptions({ headers: headers });
  }

}

private createCustomAuthorizationHeader(email, password) {
  if (email && password) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.append('Novopsych', 'webapp');
    //headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', "Basic ".concat(btoa(email+':'+password)));
    return new RequestOptions({ headers: headers });
}else{
  let headers = new Headers({ 'Content-Type': 'application/json' });
  headers.append('Novopsych', 'webapp');
  //headers.append('Access-Control-Allow-Origin', '*');
  return new RequestOptions({ headers: headers });
}
}


  put(endpoint: string, body: any, options?: RequestOptions) {
    return this.http.put(this.url + '/' + endpoint, body, options);
  }

  delete(endpoint: string, options?: RequestOptions) {
    return this.http.delete(this.url + '/' + endpoint, options);
  }

  patch(endpoint: string, body: any, options?: RequestOptions) {
    return this.http.put(this.url + '/' + endpoint, body, options);
  }

  getReportPDF (link:string){
    let userId = localStorage.getItem('userId');
    let password = localStorage.getItem('password');
    let headers = new Headers();
    headers.append("Accept", "application/pdf");
    headers.append('Novopsych', 'webapp');
    headers.append('Authorization', "Basic ".concat(btoa(userId+':'+password)));
    return this.http.get(link, {
      headers: headers,
      responseType: ResponseContentType.Blob
  }).map(res => new Blob([res.blob()], {type: "application/pdf"}));

}

//duplicating the above method as the above method may have been used somewhere
getResultPDF (endpoint :string, id: string){
  let userId = localStorage.getItem('userId');
  let password = localStorage.getItem('password');
  let headers = new Headers();
  headers.append("Accept", "application/pdf");
  headers.append('Authorization', "Basic ".concat(btoa(userId+':'+password)));
  return this.http.get(this.url + '/' + endpoint + '/' + id, {
    headers: headers,
    responseType: ResponseContentType.Blob
}).map(res => new Blob([res.blob()], {type: "application/pdf"}));

}

getReportURL(endpoint: string, reportId: string) {
    let webapp = new URLSearchParams();
    webapp.set('webapp', '1');
    let options = this.createAuthorizationHeader();
    options.search = webapp
    var response = this.http.get(this.url + '/' + endpoint + '/' + reportId, options)
      .map(res => res.json().data)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getClientReportURL(endpoint: string, reportId: string) {
      let options = this.createAuthorizationHeader();
      var response = this.http.get(this.url + '/' + endpoint + '/' + reportId, options)
        .map(res => res.json().data)
        .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
      return response;
    }
  // the below method is not required anymore as the assessments are made publicly available
  getAssessmentURL(endpoint: string, assessmentId: string) {
    let options = this.createAuthorizationHeader();
    var response = this.http.get(this.url + '/' + 'admin' + '/' + endpoint + '/' + 'form' + '/'+ assessmentId, options)
      .map(res => res.json().data)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  getBatteries(endpoint: string): Observable<Batteries[]> {
    var response = this.http.get(this.url + '/' + endpoint, this.createAuthorizationHeader())
      .map(res => <Batteries[]>res.json().data.batteries)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    return response;
  }

  addBattery(endpoint: string, body: any) {
    var response =  this.http.post(this.url + '/' + endpoint, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  editBattery(endpoint: string, body: any, id: string) {
    var response =  this.http.put(this.url + '/' + endpoint + '/' + id, JSON.stringify(body),this.createAuthorizationHeader());
    return response;

  }

  deleteBattery(endpoint: string, body:any, batteryId: string){
    return this.http.delete(this.url + '/' + endpoint + '/' + batteryId, this.createAuthorizationHeader());
  }


}


// WEBPACK FOOTER //
// ./src/providers/api.ts